import styled from "styled-components";

export const Button = styled.button`
  background-color: var(--primary-color);
  border-radius: 10px;
  border: none;
  font-size: 20px;
  padding: 7px 10px;
  width: 13rem;
  margin: 1rem auto;
  cursor:pointer;
  color: var(--light-color);
`;
export const DeleteButton = styled.button`
  background-color: red;
  border-radius: 10px;
  border: none;
  font-size: 20px;
  padding: 7px 10px;
  width: 8rem;
  color: var(--light-color);
`;

export const Select = styled.select`
  background-color: white;
  border-radius: 7px;
  border: none;
  font-size: 20px;
  padding: 4px 10px;
  color: var(--primary-color);
  box-shadow: none;

  &:focus {
    outline: none;
  }
`;

export const RoundButton = styled.button`
  border-radius: 50%;
  border: solid 5px var(--primary-color);
  background-color: ${props => props.selected == 'ON' ? 'var(--primary-color)' : 'var(--light-color)'};
  width: 3.5rem;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0.4rem;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-weight: 600;
  font-size: 1.1rem;
  color: ${props => props.selected == 'ON' ? 'var(--light-color)' : 'var(--primary-color)'};

  &:hover {
    background: white;
  }
`

export const InputField = styled.input`
  background-color: white;
  border-radius: 7px;
  border: none;
  font-size: 20px;
  padding: 4px 11px;
  color: var(--primary-color);
  box-shadow: none;

  &:focus {
    outline: none;
  }

  ${props => props.type == 'password' && `
    type: "password"
  `}
`;

export const Label = styled.span`
  color: var(--primary-color);
  font-size: 20px;
`;

export const MapArea = styled.div`
    height: 100%;
    border-radius: 10px;
    width: 100%;
    min-height: 23rem

    ${props => props.type == 'placeholder' && `
      border: solid black 1px
  `}
`
export const MapAreaData = styled.div`
    width: 100%;
    min-height: 80vh;

    ${props => props.type == 'placeholder' && `
      border: solid black 1px
  `}
`
export const QuestionField = styled.input`
  background-color: white;
  border-radius: 7px;
  border: none;
  font-size: 20px;
  padding: 4px;
  margin-top: 4px;
  margin-bottom: 10px
  width: 100%;
  
  color: var(--primary-color);
  box-shadow: none;

  &:focus {
    outline: none;
  }
`;

export const ErrorLabel = styled.div`
  color: red;
  font-size: 18px;
`

